import { Injectable, inject } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";
import { IAggridGroupParams } from "./ag-grid-group.interface";
import isEmpty from "lodash-es/isEmpty";
import cloneDeep from "lodash-es/cloneDeep";
import forEach from "lodash-es/forEach";
import find from "lodash-es/find";
import { AgGridgroupService } from "./ag-grid-group.service";
import { UtilCommon } from "app/shared/common/utils/UtilCommon";


@Injectable({
  providedIn: 'root'
})
export class AgGridGroupStore {
  readonly searchKeyword$ = new BehaviorSubject<string>("");
  readonly params$ = new BehaviorSubject<IAggridGroupParams | null>(null);
  readonly loading$ = new BehaviorSubject<boolean>(false);
  readonly data$ = new BehaviorSubject<any[]>([]);
  readonly count$ = new BehaviorSubject<string>('');
  readonly refreshTrigger$ = new Subject();

  readonly #service: AgGridgroupService = inject(AgGridgroupService);

  protected BASE_REQUEST_CONSTANT = {
    pivotCount: "pivotCount",
    pivotPaging: "pivotPaging",
  };
  public advancedFilter: any = null;
  public advancedFilter$ = new BehaviorSubject(null);
  public searchOption: string;
  public columnState;
  public columnDefs;
  public groupState = null;

  public sortModel = [];
  public filterModel = {};
  private _currentNodeOpenning = null;
  public setCurrentNodeOpenning(node: any) {
    this._currentNodeOpenning = node;
  }
  public pageAttribute: string = "";
  public isQueryGetUserAttribute: boolean = false;
  get currentNodeOpenning() {
    return this._currentNodeOpenning;
  }
  get searchKeyword() {
    return this.searchKeyword$.getValue();
  }

  get params() {
    return this.params$.getValue();
  }

  get loading() {
    return this.loading$.getValue();
  }

  get data() {
    return this.data$.getValue();
  }

  get count() {
    return this.count$.getValue();
  }

  public setLoading(loading: boolean) {
    this.loading$.next(loading);
  }

  public setData(data: any[]) {
    this.data$.next(data);
  }

  public setSearchKeyword(keyword: string) {
    this.searchKeyword$.next(keyword);
  }

  public setParams(params: IAggridGroupParams) {
    this.params$.next(params);
  }

  public buildFullTexSearchRequest(
    request: any,
    extraFtsField: string[] = [],
    isKeepFilterModel: boolean = false
  ): any {
    let filterModel: any = request.filterModel;
    let searchKeyword = this.searchKeyword;

    if (this.searchKeyword && this.searchKeyword.length > 0) {
      if (isKeepFilterModel) {
        filterModel[this.searchOption ?? "ftsValue"] = {
          type: "equals",
          filter: searchKeyword,
          filterType: "text",
        }
      } else {
        filterModel = {
          [this.searchOption ?? "ftsValue"]: {
            type: "equals",
            filter: searchKeyword,
            filterType: "text",
          },
        };
      }
    }

    if (this.advancedFilter) {
      return {
        ...request,
        filterModel: {
          ...UtilCommon.deepCloneAny(this.advancedFilter),
          ...filterModel
        }
      }
    }

    return {
      ...request,
      filterModel,
    };
  }

  public transformRequestBeforeQuery(request: any): any {
    const mapChangeCols = {};
    if (!isEmpty(mapChangeCols)) {
      request = cloneDeep(request);
      const { filterModel, sortModel } = request;

      forEach(mapChangeCols, (toCol, fromCol) => {
        if (filterModel[fromCol]) {
          filterModel[toCol] = filterModel[fromCol];
          delete filterModel[fromCol];
        }

        const sortCol = find(sortModel, (m) => m.colId === fromCol);
        if (sortCol) {
          sortCol.colId = toCol;
        }
      });
    }
    this.filterModel = request.filterModel;
    this.sortModel = request.sortModel;
    return request;
  }

  private buildUserAttribute(): any {
    // return {
    //   fullText: this.searchKeyword || "",
    //   columnState: this.columnState || [],
    //   groupState: this.groupState || [],
    //   columnDefs: this.columnDefs || [],
    //   advancedFilter: this.advancedFilter || null
    // };
    return {
      fullText: this.searchKeyword || "",
      columnState: this.columnState || [],
      groupState: this.groupState || [],
      columnDefs: this.columnDefs || [],
      advancedFilter: this.advancedFilter || null
    };
  }

  getUserAttribute(): Promise<any> {
    let localStorageUserAttribute = localStorage.getItem(
      this.pageAttribute
    );
    if (localStorageUserAttribute && localStorageUserAttribute !== "null") {
      localStorageUserAttribute = JSON.parse(localStorageUserAttribute);
      this.columnState = localStorageUserAttribute["columnState"];
      this.groupState = localStorageUserAttribute["groupState"];
      this.columnDefs = localStorageUserAttribute["columnDefs"];
      this.advancedFilter = localStorageUserAttribute["advancedFilter"];
      // this.searchKeyword$.next(localStorageUserAttribute["fullText"]);
      this.advancedFilter$.next(this.advancedFilter)
      return Promise.resolve();
    }

    this.isQueryGetUserAttribute = true;
    return this.#service
      .getUserAttribute(this.pageAttribute)
      .then((userAttribute) => {
        if (userAttribute && userAttribute.length > 0) {
          const parseJson = JSON.parse(userAttribute);
          this.columnState = parseJson?.columnState;
          this.groupState = parseJson?.groupState;
          this.columnDefs = parseJson?.columnDefs;
          this.advancedFilter = parseJson?.advancedFilter;
          // this.searchKeyword$.next(parseJson?.fullText);
          this.advancedFilter$.next(this.advancedFilter);
        }
      });
  }

  setUserAttribute(hasCallApi: boolean = false): Promise<any> {
    try {
      const userAttribute = JSON.stringify(this.buildUserAttribute());
      localStorage.setItem(
        this.pageAttribute,
        userAttribute
      );
      if (hasCallApi) {
        return this.#service.setUserAttribute(
          this.pageAttribute,
          userAttribute
        );
      } else {
        return Promise.resolve();
      }
    } catch (err) {
      return Promise.resolve();
    }
  }

  public resetUserAttribute(): any {
    const userAttribute = JSON.stringify({
      fullText: "",
      columnState: [],
      groupState: [],
      columnDefs: [],
      advancedFilter: null
    });
    localStorage.setItem(
      this.pageAttribute,
      userAttribute
    );
    return this.#service.setUserAttribute(
      this.pageAttribute,
      userAttribute
    );
  }
}
